/*!
 * aes-encryption
 * Copyright(c) 2021 CODEMONDAY
 * MIT Licensed
 */

module.exports = require('./lib/aes')
